import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../../store/store';
import { getAppSumo } from '../../../../store/appSumo/appSumo.actions';

export const AppSumo: React.FC = (): JSX.Element => {
  const { user } = useSelector((state: RootState) => state.auth);

  const { changePlanUrl, planId } = useSelector(
    (state: RootState) => state.appSumo
  );

  const dispatch = useDispatch();

  useEffect(() => {
    if (user) dispatch(getAppSumo(user.orgId));
  }, []); // eslint-disable-line

  const onUpdatePlanClick = () => {
    if (changePlanUrl?.length) {
      window.open(changePlanUrl, '_blank');
    }
  };

  const defineCurrentPlan = () => {
    let result = '';
    if (planId === 'appsumo_qbysubstrata_tier1') {
      result = 'AppSumo Tier 1';
    } else if (planId === 'appsumo_qbysubstrata_tier2') {
      result = 'AppSumo Tier 2';
    } else if (planId === 'appsumo_qbysubstrata_tier3') {
      result = 'AppSumo Tier 3';
    }
    return result;
  };

  const attrs = {
    wrapper: {
      className: 'app-sumo',
    },
    header: {
      wrapper: {
        className: 'app-sumo__header',
      },
      detailes: {
        wrapper: {
          className: 'app-sumo__header__details',
        },
        title: {
          className: 'app-sumo__header__details-title',
        },
        value: {
          className: 'app-sumo__header__details-value',
        },
      },
      button: {
        className: 'app-sumo__header-button',
        onClick: onUpdatePlanClick,
      },
    },
    body: {
      wrapper: {
        className: 'app-sumo__body',
      },
      titleCol: {
        className: 'app-sumo__body__title-column',
      },
      tierOne: {
        className:
          planId === 'appsumo_qbysubstrata_tier1'
            ? 'active app-sumo__body__tier-one'
            : 'app-sumo__body__tier-one',
      },
      tierTwo: {
        className:
          planId === 'appsumo_qbysubstrata_tier2'
            ? 'active app-sumo__body__tier-two'
            : 'app-sumo__body__tier-two',
      },
      tierThree: {
        className:
          planId === 'appsumo_qbysubstrata_tier3'
            ? 'active app-sumo__body__tier-three'
            : 'app-sumo__body__tier-three',
      },
      columnDivider: {
        className: 'app-sumo__body-column-divider',
      },
      row: {
        className: 'app-sumo__body-row',
      },
      titleRow: {
        wrapper: {
          className: 'title app-sumo__body-row',
        },
        subTitle: {
          className: 'title-subtitle app-sumo__body-row',
        },
      },
      titleColumnRow: {
        className: 'title-column app-sumo__body-row',
      },
    },
    footer: {
      wrapper: {
        className: 'app-sumo__footer',
      },
      empty: {
        className: 'app-sumo__footer-empty',
      },
      tierOne: {
        className:
          planId === 'appsumo_qbysubstrata_tier1'
            ? 'app-sumo__footer-tier-one'
            : 'link app-sumo__footer-tier-one',
      },
      tierTwo: {
        className:
          planId === 'appsumo_qbysubstrata_tier2'
            ? 'app-sumo__footer-tier-two'
            : 'link app-sumo__footer-tier-two',
      },
      tierThree: {
        className:
          planId === 'appsumo_qbysubstrata_tier3'
            ? 'app-sumo__footer-tier-three'
            : 'link app-sumo__footer-tier-three',
      },
    },
  };

  const currentPlan = defineCurrentPlan();

  const checkMark = (
    <svg
      width="21"
      height="16"
      viewBox="0 0 21 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M1 9.5L6 14.5L19.5 1" stroke="#4D4558" strokeWidth="2" />
    </svg>
  );

  const titleColumn = (
    <>
      <div {...attrs.body.titleRow.wrapper} />
      <div {...attrs.body.titleColumnRow}>Message & thread analysis</div>
      <div {...attrs.body.titleColumnRow}>Authority zone</div>
      <div {...attrs.body.titleColumnRow}>Pragmatic sentiment analysis</div>
      <div {...attrs.body.titleColumnRow}> Average perceived authority</div>
      <div {...attrs.body.titleColumnRow}> Upper-hand analysis</div>
      <div {...attrs.body.titleColumnRow}> Next move recommendations</div>
      <div {...attrs.body.titleColumnRow}>Draft-mode simulator</div>
      <div {...attrs.body.titleColumnRow}> Real-time event notifications</div>
      <div {...attrs.body.titleColumnRow}> Aggregate Interaction analytics</div>
    </>
  );

  const tierColumn = (
    <>
      <div {...attrs.body.row}>{checkMark}</div>
      <div {...attrs.body.row}>{checkMark}</div>
      <div {...attrs.body.row}>{checkMark}</div>
      <div {...attrs.body.row}>{checkMark}</div>
      <div {...attrs.body.row}>{checkMark}</div>
      <div {...attrs.body.row}>{checkMark}</div>
      <div {...attrs.body.row}>{checkMark}</div>
      <div {...attrs.body.row}>{checkMark}</div>
      <div {...attrs.body.row}>{checkMark}</div>
    </>
  );

  const emptyColumnFooter = <span {...attrs.footer.empty} />;

  const tierOneFooter =
    planId === 'appsumo_qbysubstrata_tier1' ? (
      <span {...attrs.footer.tierOne}>Current Tier</span>
    ) : (
      <span {...attrs.footer.tierOne} onClick={onUpdatePlanClick}>
        Downgrade
      </span>
    );

  const tierTwoFooter =
    planId === 'appsumo_qbysubstrata_tier2' ? (
      <span {...attrs.footer.tierTwo}>Current Tier</span>
    ) : (
      <span {...attrs.footer.tierTwo} onClick={onUpdatePlanClick}>
        {planId === 'appsumo_qbysubstrata_tier3' ? 'Downgrade' : 'Upgrade'}
      </span>
    );

  const tierThreeFooter =
    planId === 'appsumo_qbysubstrata_tier3' ? (
      <span {...attrs.footer.tierThree}>Current Tier</span>
    ) : (
      <span {...attrs.footer.tierThree} onClick={onUpdatePlanClick}>
        Upgrade
      </span>
    );

  return (
    <div {...attrs.wrapper}>
      <div {...attrs.header.wrapper}>
        <div {...attrs.header.detailes.wrapper}>
          <span {...attrs.header.detailes.title}>Plan Details</span>
          <span {...attrs.header.detailes.value}>{currentPlan}</span>
        </div>
        <button {...attrs.header.button}>Manage License</button>
      </div>
      <div {...attrs.body.wrapper}>
        <div {...attrs.body.titleCol}>{titleColumn}</div>
        <div {...attrs.body.tierOne}>
          <div {...attrs.body.titleRow.wrapper}>
            <span>AppSumo Tier 1</span>
            <span {...attrs.body.titleRow.subTitle}>1 Dealmaker</span>
          </div>
          {tierColumn}
        </div>
        <div {...attrs.body.tierTwo}>
          <div {...attrs.body.titleRow.wrapper}>
            <span>AppSumo Tier 2</span>
            <span {...attrs.body.titleRow.subTitle}>3 Dealmakers</span>
          </div>
          {tierColumn}
        </div>
        <div {...attrs.body.tierThree}>
          <div {...attrs.body.titleRow.wrapper}>
            <span>AppSumo Tier 3</span>
            <span {...attrs.body.titleRow.subTitle}>5 Dealmakers</span>
          </div>
          {tierColumn}
        </div>
      </div>
      <div {...attrs.footer.wrapper}>
        {emptyColumnFooter}
        {tierOneFooter}
        {tierTwoFooter}
        {tierThreeFooter}
      </div>
    </div>
  );
};
